import {
  Calculator,
  Receipt,
  Building2,
  Briefcase,
  FileText,
  PieChart,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const categories = [
  {
    title: "Income Tax",
    icon: Calculator,
    img: "https://i.pinimg.com/736x/b7/47/22/b747226ca471f60b6c298f82627b2014.jpg",
    description: "Personal and business income tax guidelines",
  },
  {
    title: "GST",
    icon: Receipt,
    img: "https://i.pinimg.com/736x/48/25/99/4825994a42c8af8e03699012f6ba59ec.jpg",
    description: "Goods and Services Tax updates and compliance",
  },
  {
    title: "NG",
    icon: Building2,
    img: "https://i.pinimg.com/736x/00/43/3f/00433fa1b07a0a4e01ca419a62e4762d.jpg",
    description: "Non-Government Organization tax regulations",
  },
  {
    title: "Professional",
    icon: Briefcase,
    img: "https://i.pinimg.com/736x/bf/3f/7b/bf3f7b0a43431180e3ae27bc841926f3.jpg",
    description: "Tax services for professionals and consultants",
  },
  {
    title: "TDS",
    icon: FileText,
    img: "https://i.pinimg.com/736x/79/f6/98/79f698ad7210d3787894cc6f07f69ba6.jpg",
    description: "Tax Deducted at Source guidelines",
  },
  {
    title: "TCS",
    icon: PieChart,
    img: "https://i0.wp.com/taxconcept.net/wp-content/uploads/2020/11/WhatsApp-Image-2020-11-17-at-1.31.16-PM.jpeg?w=1080&ssl=1",
    description: "Tax Collected at Source regulations",
  },
];

export function Categories({ data }) {
  const navigate = useNavigate();

  const handleclick = (name, link) => {
    navigate(`/blogcategory/${name}`, {
      replace: true,
      state: { link, name, data },
    });
  };

  return (
    <section className="py-10 px-4 md:px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold text-[#151C62] mb-12 text-center">
          Categories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-8">
          {categories.map((category) => (
            <a
              key={category.title}
              className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow"
            >
              <button onClick={() => handleclick(category.title, category.img)}>
                <div className="relative h-20 w-full">
                  <img
                    src={category.img || "/placeholder.svg"}
                    alt={category.title}
                    fill
                    className="object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-[-10px] bg-[#151C62] opacity-60 group-hover:opacity-70 transition-opacity" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                    <category.icon className="w-12 h-12 mb-4" />
                    <h3 className="text-2xl font-bold mb-2">
                      {category.title}
                    </h3>
                  </div>
                </div>
              </button>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
